"use client";

import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from "react-bootstrap";
import { useCartStore } from '../../../../store/cart-store';
import { FILES_BASE_URL } from '../../../../config';

const CartIcon: React.FC = () => {
  const { items, getTotalItems, removeItem } = useCartStore();
  const totalItems = getTotalItems();

  return (
    <Dropdown className="dropdown notifications noti">
      <Dropdown.Toggle
        variant="secondary"
        id="dropdown-basic"
        className="border-0 p-0 position-relative"
      >
        <i className="material-symbols-outlined">shopping_cart</i>
        {totalItems > 0 && (
          <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
            {totalItems < 10 ? totalItems : '9+'}
          </span>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-lg p-0 border-0 p-0 dropdown-menu-end">
        <div className="d-flex justify-content-between align-items-center title">
          <span className="fw-semibold fs-15 text-secondary">
            Carrito{" "}
            <span className="fw-normal text-body fs-14">
              ({totalItems})
            </span>
          </span>
          <button 
            className="p-0 m-0 bg-transparent border-0 fs-14 text-primary"
            onClick={() => removeItem('all')}
          >
            Vaciar
          </button>
        </div>

        <div className="max-h-217 scrollbar">
          {items.length > 0 ? (
            items.slice(0, 4).map((item, index) => (
              <div className="notification-menu" key={index}>
                <Link to={`/store/product-details/${item._id}`} className="dropdown-item">
                  <div className="d-flex align-items-center">
                    <div className="flex-shrink-0">
                      {item.images && item.images.length > 0 ? (
                        <img 
                          src={`${FILES_BASE_URL}/${item.images[0]}`} 
                          alt={item.title} 
                          className="rounded" 
                          width="40" 
                          height="40" 
                        />
                      ) : (
                        <i className="material-symbols-outlined text-primary">shopping_bag</i>
                      )}
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p>{item.title}</p>
                      <span className="fs-13">{item.quantity || 1} x ${item.aditionalData?.[0]?.price_local_currency?.toLocaleString() || 0} COP</span>
                    </div>
                  </div>
                </Link>
              </div>
            ))
          ) : (
            <div className="notification-menu">
              <div className="dropdown-item text-center">
                <i className="material-symbols-outlined text-muted">shopping_cart</i>
                <p className="mt-2 mb-0">Tu carrito está vacío</p>
              </div>
            </div>
          )}
        </div>

        <Link
          
          to="/store/cart"
          className="dropdown-item text-center text-primary d-block view-all fw-medium rounded-bottom-3"
        >
          <span>Ver Carrito Completo</span>
        </Link>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CartIcon;
